module.exports = __webpack_public_path__ + "137253fd3fdaeb8c5e2522f24ec7fb1c.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe/welldone.png
// module id = 43
// module chunks = 0